import React, { useEffect } from "react";
import { Icon } from "@iconify/react";
import { setPageSeo } from "../seo";

const demoSeo = {
  title: "Anteprima Cards | Demo",
  description: "Pagina demo con dati fittizi per visualizzare una Cards.",
  path: "/anteprima",
  imagePath: "/mockup-hero.png",
  robots: "noindex,nofollow,noarchive",
};

function QrPlaceholder() {
  const activeCells = new Set([
    0, 1, 2, 5, 6, 7, 10, 11, 12, 18, 19, 20, 23, 24, 25, 30, 31, 36, 38, 42,
    43, 44, 47, 49, 54, 55, 60, 62, 64, 66, 70, 71, 72, 75, 76, 77, 78, 80,
  ]);

  return (
    <div className="grid h-24 w-24 shrink-0 grid-cols-9 gap-1 rounded bg-slate-950 p-2">
      {Array.from({ length: 81 }).map((_, index) => (
        <span
          key={index}
          className={`rounded-[1px] ${
            activeCells.has(index) ? "bg-white" : "bg-slate-950"
          }`}
        />
      ))}
    </div>
  );
}

function ContactRow({ icon, label, value }) {
  return (
    <div className="flex items-center rounded-xl bg-[#f2f4f7]/50 p-4">
      <div className="mr-4 rounded-lg bg-[#20acad]/10 p-2">
        <Icon icon={icon} className="text-2xl text-[#20acad]" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm text-gray-500">{label}</p>
        <p className="truncate font-medium text-gray-900">{value}</p>
      </div>
      <Icon icon="mdi:chevron-right" className="text-xl text-gray-400" />
    </div>
  );
}

function PreviewPage() {
  useEffect(() => {
    setPageSeo(demoSeo);
  }, []);

  return (
    <main className="min-h-screen bg-[#f2f4f7] px-4 py-8 font-sans">
      <div className="mx-auto mb-6 flex w-full max-w-md items-center justify-between gap-3">
        <a
          href="/"
          className="inline-flex items-center gap-2 rounded-md bg-white px-3 py-2 text-xs font-bold text-[#13526f] shadow-sm ring-1 ring-slate-200"
        >
          <Icon icon="mdi:arrow-left" className="text-base" />
          Torna al sito
        </a>
        <span className="rounded-full bg-white px-3 py-2 text-xs font-bold text-slate-500 shadow-sm ring-1 ring-slate-200">
          Demo con dati fittizi
        </span>
      </div>

      <article className="mx-auto w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-lg">
        <header className="relative bg-gradient-to-r from-[#1b8395] to-[#20acad] pb-8 pt-8 text-center">
          <button
            type="button"
            className="absolute right-4 top-4 rounded-full bg-white/20 p-2 text-white"
            aria-label="Condividi"
          >
            <Icon icon="mdi:share-variant" className="text-xl" />
          </button>

          <div className="mx-auto mb-3 flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-white/20 ring-2 ring-white/25">
            <Icon icon="mdi:account" className="text-3xl text-white" />
          </div>
          <h1 className="mb-1 text-2xl font-bold text-white">Luca Ferri</h1>
          <p className="mb-2 text-sm font-semibold text-cyan-50">
            Consulente commerciale
          </p>
          <p className="mb-4 flex items-center justify-center font-medium text-white/90">
            <Icon icon="mdi:office-building" className="mr-1 text-sm" />
            Ferri Servizi Funebri
          </p>
          <div className="flex justify-center gap-3">
            {["mdi:web", "mdi:linkedin", "mdi:facebook", "mdi:instagram"].map(
              (icon) => (
                <span
                  key={icon}
                  className="rounded-full bg-white/20 p-2 text-white"
                >
                  <Icon icon={icon} className="text-base" />
                </span>
              ),
            )}
          </div>
        </header>

        <div className="px-6 pt-6">
          <div className="mb-6 flex gap-3">
            <button
              type="button"
              className="flex-1 rounded-xl bg-[#20acad] py-4 font-semibold text-white shadow-md"
            >
              <Icon icon="mdi:account-plus" className="mr-2 inline text-xl" />
              Aggiungi ai contatti
            </button>
            <button
              type="button"
              className="flex h-auto w-12 items-center justify-center rounded-xl bg-[#f2f4f7] text-[#1b8395]"
              aria-label="QR code"
            >
              <Icon icon="ion:qr-code" className="text-xl" />
            </button>
          </div>

          <h2 className="mb-4 text-lg font-semibold text-[#1b8395]">
            Contatti Personali
          </h2>
          <div className="mb-8 space-y-3">
            <ContactRow
              icon="mdi:cellphone"
              label="Cellulare"
              value="+39 333 123 4567"
            />
            <ContactRow
              icon="mdi:email"
              label="Email"
              value="luca.ferri@example.it"
            />
            <ContactRow
              icon="mdi:whatsapp"
              label="WhatsApp"
              value="Chatta su WhatsApp"
            />
          </div>

          <button
            type="button"
            className="mb-8 block w-full rounded-xl bg-[#f9c534] py-4 text-center font-semibold text-black shadow-md"
          >
            <Icon icon="mdi:phone" className="mr-2 inline text-xl" />
            Chiama ora
          </button>

          <h2 className="mb-4 text-lg font-semibold text-[#1b8395]">
            Contatti Aziendali
          </h2>
          <div className="mb-8 space-y-3">
            <div className="rounded-xl border border-gray-100 bg-white p-4 shadow-sm">
              <div className="mx-auto flex h-16 max-w-[220px] items-center justify-center rounded-md bg-slate-50 text-sm font-extrabold text-[#13526f] ring-1 ring-slate-200">
                FERRI SERVIZI FUNEBRI
              </div>
            </div>
            <div className="rounded-xl bg-[#f2f4f7]/50 p-4">
              <p className="text-sm font-semibold text-gray-500">
                Descrizione
              </p>
              <p className="mt-1 text-sm leading-6 text-gray-700">
                Supporto commerciale per imprese funebri, partner e servizi di
                filiera.
              </p>
            </div>
            <ContactRow
              icon="mdi:email-outline"
              label="Email ufficio"
              value="info@ferriservizi.example"
            />
            <ContactRow
              icon="ph:phone-fill"
              label="Telefono ufficio"
              value="+39 06 1234 5678"
            />
            <ContactRow
              icon="mdi:web"
              label="Sito web"
              value="www.ferriservizi.example"
            />
            <ContactRow
              icon="mdi:map-marker"
              label="Sede"
              value="Via Roma 25, Roma"
            />
          </div>

          <div className="mb-8 rounded-xl bg-white p-4 shadow-sm ring-1 ring-slate-200">
            <div className="flex items-center gap-4">
              <QrPlaceholder />
              <div>
                <p className="text-sm font-extrabold text-slate-900">
                  QR Cards
                </p>
                <p className="mt-1 text-sm font-medium leading-5 text-slate-600">
                  Il QR rimanda alla card pubblica e resta valido anche dopo
                  l'aggiornamento dei dati.
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>
    </main>
  );
}

export default PreviewPage;
